// removed by extract-text-webpack-plugin
module.exports = {"plans":"plans__10fbp","headerContainer":"headerContainer__22Qls","header":"header__1Cvms","percentage":"percentage__2rlbI"};


//////////////////
// WEBPACK FOOTER
// ./components/homePageNew/topPlansSection/topPlansSection.scss
// module id = 505
// module chunks = 68